import { EVALUATION_DATA_FAILURE, EVALUATION_DATA_REQUEST, EVALUATION_DATA_SUCCESS, GET_FOOTER_DATE, MEDICAL_RECORD_DATA_FAILURE, MEDICAL_RECORD_DATA_REQUEST, MEDICAL_RECORD_DATA_SUCCESS, QUICKFILTER_DATA_REQUEST, QUICKFILTER_DATA_SUCCESS, QUICKFILTER_DATA_FAILURE, EVALUATION_ADJUSTMENT_DATA_REQUEST, EVALUATION_ADJUSTMENT_DATA_SUCCESS, EVALUATION_ADJUSTMENT_DATA_FAILURE, KNOWLEDGE_CENTRE_DATA_REQUEST, 
    KNOWLEDGE_CENTRE_DATA_SUCCESS, GLOSSARY_LIST_DATA, REASON_CODE_DATA_REQUEST, EVALUATION_DETAILS_DATA_SUCCESS, EVALUATION_DETAILS_DATA_REQUEST, SELECTED_RADIO_OPTIONS, 
    EVALUATION_DATA_LOADING,
    REASON_CODE_DATA_LOADING,
    MEDICAL_RECORD_DATA_LOADING,
    EVALUATION_ADJUSTMENT_DATA_LOADING,
    OVERTURNS_DATA_REQUEST,
    OVERTURNS_DATA_LOADING,
    OVERTURNS_DATA_SUCCESS,
    OVERTURNS_DATA_FAILURE,
    INIT_PI_FILTERS,
    UPDATE_PI_FILTERS,
    RESET_PI_FILTERS,
    SET_PI_GEO_VENDOR_OPTIONS,
    SET_PI_PROVIDER_SIGNATURE} from "@src/middleware/actions/actionTypes"

export const fetchEvaluationDataRequest = (payload: any) => ({
    type: EVALUATION_DATA_REQUEST,
    payload
});
export const fetchEvaluationDataLoading = (payload: any) => ({
    type: EVALUATION_DATA_LOADING,
    payload
});
export const fetchEvaluationDataSuccess = (payload: any) => ({
    type: EVALUATION_DATA_SUCCESS,
    payload
});
export const fetchEvaluationDataError = (payload: any) => ({
    type: EVALUATION_DATA_FAILURE,
    payload
});

export const getfooterDate = (payload: any) => ({
    type: GET_FOOTER_DATE,
    payload
});

export const fetchMedicalRecordDataRequest = (payload: any) => ({
    type: MEDICAL_RECORD_DATA_REQUEST,
    payload
});
export const fetchMedicalRecordDataloading = (payload: any) => ({
    type: MEDICAL_RECORD_DATA_LOADING,
    payload
});
export const fetchMedicalRecordDataSuccess = (payload: any) => ({
    type: MEDICAL_RECORD_DATA_SUCCESS,
    payload
});
export const fetchMedicalRecordDataError= (payload: any) => ({
    type: MEDICAL_RECORD_DATA_FAILURE,
    payload
});

export const fetchEvaluationAdjustmentDataRequest = (payload: any) => ({
    type: EVALUATION_ADJUSTMENT_DATA_REQUEST,
    payload
});

export const fetchEvaluationAdjustmentDataLoading = (payload: any) => ({
    type: EVALUATION_ADJUSTMENT_DATA_LOADING,
    payload
});

export const fetchEvaluationAdjustmentDataSuccess = (payload: any) => ({
    type: EVALUATION_ADJUSTMENT_DATA_SUCCESS,
    payload
});
export const fetchEvaluationAdjustmentDataError= (payload: any) => ({
    type: EVALUATION_ADJUSTMENT_DATA_FAILURE,
    payload
});

export const fetchOverturnsDataRequest = (payload: any) => ({
    type: OVERTURNS_DATA_REQUEST,
    payload
});

export const fetchOverturnsDataLoading = (payload: any) => ({
    type: OVERTURNS_DATA_LOADING,
    payload
});

export const fetchOverturnsDataSuccess = (payload: any) => ({
    type: OVERTURNS_DATA_SUCCESS,
    payload
});

export const fetchOverturnsDataError = (payload: any) => ({
    type: OVERTURNS_DATA_FAILURE,
    payload
});

export const getQuickFilterDataRequest = (payload: any) => ({
    type: QUICKFILTER_DATA_REQUEST,
    payload
});

export const getQuickFilterDataSuccess = (payload: any) => ({
    type: QUICKFILTER_DATA_SUCCESS,
    payload
});
export const getQuickFilterDataError= (payload: any) => ({
    type: QUICKFILTER_DATA_FAILURE,
    payload
});

export const getKnowLedgeCentreDataRequest = (payload: any) => ({
    type: KNOWLEDGE_CENTRE_DATA_REQUEST,
    payload
});

export const knowLedgeCentreDataSuccess = (payload: any) => ({
    type: KNOWLEDGE_CENTRE_DATA_SUCCESS,
    payload
});
export const knowLedgeCentreGlosasryList = (payload: any) => ({
    type: GLOSSARY_LIST_DATA,
    payload
});

export const reasonCodeTableDataRequest = (payload: any) => ({
    type: REASON_CODE_DATA_REQUEST,
    payload
});
export const reasonCodeTableDataLoading = (payload: any) => ({
    type: REASON_CODE_DATA_LOADING,
    payload
});

export const fetchEvaluationDetailsDataSuccess = (payload: any) => ({
    type: EVALUATION_DETAILS_DATA_SUCCESS,
    payload
})
export const fetchEvaluationDetailsDataRequest = (payload: any,selectedRadioValue) => ({
    type: EVALUATION_DETAILS_DATA_REQUEST,
    payload,
    selectedRadioValue
});
export const getSelectedRadioOptions = (payload: any) => ({
    type: SELECTED_RADIO_OPTIONS,
    payload
});

// PI Filters — Redux-first filter state management
export const initPIFilters = (payload: any) => ({
    type: INIT_PI_FILTERS,
    payload
});

export const updatePIFilters = (payload: any) => ({
    type: UPDATE_PI_FILTERS,
    payload
});

export const resetPIFilters = (payload: any) => ({
    type: RESET_PI_FILTERS,
    payload
});

export const setPIGeoVendorOptions = (payload: any) => ({
    type: SET_PI_GEO_VENDOR_OPTIONS,
    payload
});

export const setPIProviderSignature = (payload: string) => ({
    type: SET_PI_PROVIDER_SIGNATURE,
    payload
});
